import { logoClockWhite } from "#webapp/src/assets/img/logos";
import { TrackingEvents, track } from "#webapp/src/util/analytics.util";
import { Button } from "@clockwise/design-system";
import { ChevronRight } from "@clockwise/design-system/icons";
import {
  appPaths,
  webappDefaultWindowName,
} from "@clockwise/web-commons/src/constants/route.constants";
import React from "react";
export const ChromeWelcome = () => {
  const openWebapp = () => {
    track(TrackingEvents.ONBOARDING.ONBOARDING_EXTENSION_CONTINUE_SETUP);
    window.open(appPaths.landing, webappDefaultWindowName);
  };

  return (
    <div className="cw-flex cw-flex-col cw-items-center cw-h-full cw-pt-12 cw-pb-3 cw-px-8">
      <div className="cw-flex cw-flex-col cw-items-center cw-justify-center">
        <div className="cw-flex cw-items-center cw-justify-center cw-w-[110px] cw-h-[110px] cw-rounded-full cw-bg-brand-emphasis">
          <img src={logoClockWhite} className="cw-w-[70px]" />
        </div>
        <div className="cw-flex cw-flex-col cw-items-center cw-p-2 cw-pt-4">
          <div className="cw-heading-base cw-mb-2 cw-text-center">
            Almost there! Please finish set up to use Clockwise
          </div>
          <div className="cw-pt-3">
            <Button sentiment="positive" size="large" endIcon={ChevronRight} onClick={openWebapp}>
              Get started
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
